import { ContentScrollableComponent } from './../reports/components/ContentScrollable/content-scrollable.component';
import { registerLocaleData } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import ptBr from '@angular/common/locales/pt';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonsLibModule } from 'commons-lib';
import { NavigationModule } from 'lps-navigation';

import { NgxMaskModule } from 'ngx-mask';
import { ChartsModule } from 'ng2-charts';
import { TranslateModule } from '@ngx-translate/core';

import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule, MatRadioModule, MatSlideToggleModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PlatformModule } from '@angular/cdk/platform';

import { CdkStepperModule } from '@angular/cdk/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';
import { MaterialModule } from './material.module';

import { SnackbarService } from './components/snackbar/service/snackbar.service';
import { ModalOrderComponent } from './components/modal-order/modal-order.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { SideNavComponent } from './components/sidenav/sidenav.component';
import { DropdownButtonComponent } from './components/dropdown-button/dropdown-button.component';
import { BrokerProfileCardComponent } from './components/broker-profile-card/broker-profile-card.component';
import { ModalEditComponent } from './components/modal-edit/modal-edit.component';
import { DndCardComponent } from './components/dnd-card/dnd-card.component';
import { FlagInputComponent } from './components/flag-input/flag-input.component';
import { DropdownIconComponent } from './components/dropdown-icon/dropdown-icon.component';
import { ButtonsPopupComponent } from './components/buttons-popup/buttons-popup.component';
import { SearchProfileCardComponent } from './components/search-profile-card/search-profile-card.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { SelectOptionsComponent } from './components/select-options/select-options.component';
import { ZipCodeFlagInputComponent } from './components/zip-code-flag-input/zip-code-flag-input.component';
import { DndTableComponent } from './components/dnd-table/dnd-table.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { PropertiesTableComponent } from './components/properties-table/properties-table.component';
import { ListActionComponent } from './components/list-action/list-action.component';
import { ProductRegistrationComponent } from './components/product-registration/product-registration.component';
import { ProductRegCardComponent } from './components/product-registration/product-search/product-reg-card/product-reg-card.component';
import { ProductSearchComponent } from './components/product-registration/product-search/product-search.component';
import { InputComponent } from './components/input/input.component';
import { CongratulationComponent } from './components/congratulations/congratulations.component';
import { AddressRegistryComponent } from './components/address-registry/address-registry.component';
import { ProprietaryComponent } from './components/proprietary/proprietary.component';
import { ProprietaryModalComponent } from './components/proprietary-modal/proprietary-modal.component';
import { SaleAndRentComponent } from './components/sale-and-rent/sale-and-rent.component';
import { CoreModule } from '../core/core.module';
import { DropDownComponent } from './components/dropdown/dropdown.component';
import { FilterPipe } from './components/dropdown/dropdown.pipe';
import { DropdownInputListComponent } from './components/dropdown-input-list/dropdown-input-list.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { DefaultDialogComponent } from './components/default-dialog/default-dialog.component';
import { SlideToggleComponent } from './components/slide-toggle/slide-toggle.component';
import { TagsComponent } from './components/tags/tags.component';
import { MultiSelectionTagsComponent } from './components/multi-selection-tags/multi-selection-tags.component';
import { MultiSelectionDropdownComponent } from './components/multi-selection-dropdown/multi-selection-dropdown.component';
import { TeamManagementTableComponent } from './components/team-management-table/team-management-table';
import { ModalWorkScheduleComponent } from './components/modal-work-schedule/modal-work-schedule.component';
import { ModalConfigUsersComponent } from './components/modal-config-users/modal-config-users.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { CaptureUnitProductComponent } from './components/capture-unit-product/capture-unit-product.component';
import { CaptureUnitProductModalComponent } from './components/capture-unit-product/capture-unit-product-modal/capture-unit-product-modal.component';
import { MoreInformationComponent } from './components/more-information/more-information.component';
import { ParticipantsModalComponent } from './components/participants-modal/participants-modal.component';
import { RangeSelectorComponent } from './components/range-selector/range-selector.component';
import { ProfessionalModalComponent } from './components/professional-modal/professional-modal.component';
import { PropertiesCardComponent } from './components/properties-card/properties-card.component';
import { TblLeadsComponent } from './components/tbl-leads/tbl-leads.component';
import { ImpoundedLeadsComponent } from '../reports/components/ImpoundedLeads/impounded-leads.component';
import { FilterImpoundedLeadsComponent } from '../reports/components/FilterImpoundedLeads/filter-impounded-leads.component';
import { FilterLeadsComponent } from '../reports/components/FilterLeads/filter-leads.component';
import { ContactComponent } from '../reports/components/ContactComponent/contact.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { ButtonOptionComponent } from './components/button-option/button-option.component';
import { DropdownTagsComponent } from './components/dropdown-tags/dropdown-tags.component';
import { TodayScheduleComponent } from './components/today-schedule/today-schedule.component';
import { InputTagComponent } from './components/input-tag/input-tag.component';
import { ButtonsListComponent } from './components/buttons-list/buttons-list.component';
import { SortArrowsComponent } from './components/sort-arrows/sort-arrows.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { CardInfoComponent } from './components/card-info/card-info.component';
import { InputSearchComponent } from './components/input-search/input-search.component';
import { FlagComponentModule } from './components/flag-component/flag-component.module';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import { NotFoundPageComponent } from './components/not-found/not-found-page.component';
import { ButtonsFiltersComponent } from './components/buttons-filters/buttons-filters.component';
import { IconModule } from '../profile/components/icon/icon.module';
import { ScrollTopMobileComponent } from './components/scroll-top-mobile/scroll-top-mobile.component';
import { ButtonCustomComponent } from './components/button-custom/button-custom.component';

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    RangeSelectorComponent,
    ModalOrderComponent,
    TabsComponent,
    SideNavComponent,
    DropdownButtonComponent,
    DropdownIconComponent,
    BrokerProfileCardComponent,
    ProfileCardComponent,
    ModalEditComponent,
    DndCardComponent,
    FlagInputComponent,
    ButtonsPopupComponent,
    SearchProfileCardComponent,
    SnackbarComponent,
    SelectOptionsComponent,
    ZipCodeFlagInputComponent,
    DndTableComponent,
    StepperComponent,
    PropertiesTableComponent,
    ListActionComponent,
    ProductRegistrationComponent,
    ProductRegCardComponent,
    ProductSearchComponent,
    CongratulationComponent,
    AddressRegistryComponent,
    ProprietaryComponent,
    ProprietaryModalComponent,
    SaleAndRentComponent,
    DropDownComponent,
    FilterPipe,
    DropdownInputListComponent,
    AutocompleteComponent,
    DefaultDialogComponent,
    SlideToggleComponent,
    TagsComponent,
    MultiSelectionTagsComponent,
    MultiSelectionDropdownComponent,
    TeamManagementTableComponent,
    ModalWorkScheduleComponent,
    ModalConfigUsersComponent,
    TimepickerComponent,
    CaptureUnitProductComponent,
    CaptureUnitProductModalComponent,
    MoreInformationComponent,
    ParticipantsModalComponent,
    ProfessionalModalComponent,
    PropertiesCardComponent,
    TblLeadsComponent,
    ImpoundedLeadsComponent,
    FilterImpoundedLeadsComponent,
    FilterLeadsComponent,
    ContactComponent,
    CalendarComponent,
    ButtonOptionComponent,
    DropdownTagsComponent,
    TodayScheduleComponent,
    InputTagComponent,
    InputComponent,
    ButtonsListComponent,
    SortArrowsComponent,
    AccordionComponent,
    CardInfoComponent,
    ContentScrollableComponent,
    InputSearchComponent,
    NotFoundPageComponent,
    ButtonsFiltersComponent,
    ScrollTopMobileComponent,
    ButtonCustomComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    CommonsLibModule.forRoot(),
    ChartsModule,
    MatDialogModule,
    NgxMaskModule.forRoot({}),
    MatTooltipModule,
    PlatformModule,
    NgZorroAntdModule,
    MatExpansionModule,
    CdkStepperModule,
    CommonModule,
    NavigationModule,
    CoreModule,
    MatRadioModule,
    MatSlideToggleModule,
    OverlayModule,
    FlagComponentModule,
    IconModule
  ],
  entryComponents: [
    ModalOrderComponent, DefaultDialogComponent, CaptureUnitProductModalComponent
  ],
  exports: [
    RangeSelectorComponent,
    CommonModule,
    CommonsLibModule,
    NavigationModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    MaterialModule,
    ModalOrderComponent,
    TabsComponent,
    SideNavComponent,
    DropdownButtonComponent,
    DropdownIconComponent,
    BrokerProfileCardComponent,
    ProfileCardComponent,
    MatDialogModule,
    ModalEditComponent,
    DndCardComponent,
    FlagInputComponent,
    ButtonsPopupComponent,
    SearchProfileCardComponent,
    MatTooltipModule,
    SnackbarComponent,
    SelectOptionsComponent,
    ZipCodeFlagInputComponent,
    DndTableComponent,
    TranslateModule,
    StepperComponent,
    PropertiesTableComponent,
    ListActionComponent,
    ProductRegistrationComponent,
    MatExpansionModule,
    CdkStepperModule,
    CongratulationComponent,
    AddressRegistryComponent,
    ProprietaryComponent,
    ProprietaryModalComponent,
    SaleAndRentComponent,
    DropDownComponent,
    DropdownInputListComponent,
    AutocompleteComponent,
    SlideToggleComponent,
    TagsComponent,
    MultiSelectionTagsComponent,
    MultiSelectionDropdownComponent,
    TeamManagementTableComponent,
    ModalWorkScheduleComponent,
    ModalConfigUsersComponent,
    TimepickerComponent,
    CaptureUnitProductComponent,
    MoreInformationComponent,
    OverlayModule,
    ParticipantsModalComponent,
    ProfessionalModalComponent,
    PropertiesCardComponent,
    ImpoundedLeadsComponent,
    FilterImpoundedLeadsComponent,
    FilterLeadsComponent,
    ContactComponent,
    CalendarComponent,
    ButtonOptionComponent,
    DropdownTagsComponent,
    TodayScheduleComponent,
    InputTagComponent,
    InputComponent,
    ButtonsListComponent,
    SortArrowsComponent,
    AccordionComponent,
    CardInfoComponent,
    ContentScrollableComponent,
    InputSearchComponent,
    FlagComponentModule,
    ButtonsFiltersComponent,
    ScrollTopMobileComponent,
    ButtonCustomComponent
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-PT' },
    { provide: NZ_I18N, useValue: en_US },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    SnackbarService
  ]
})
export class SharedModule { }
